<template>
  <div class="col-12 sector px-3">
    <div v-if="form.prom_code_id" class="d-flex justify-content-start align-items-center flex-wrap text-info">
      <i class="fa fa-ticket fa-lg mr-2" aria-hidden="true"></i>
      <span class="mr-3">{{ dt(state.discountCode?.promotion?.title_translations) }}</span>

      <span class="mr-3 text-primary">
        -{{ currencyFormat(promotionCodeDiscount | 0) }}
      </span>

      <el-button type="danger" link @click="removeDiscountCode">{{ t("global.remove") }}</el-button>
    </div>
    <el-button
      v-else
      type="primary"
      link
      size="large"
      @click="onClickDiscountCode"
    >
      <i class="fa fa-ticket fa-lg mr-2" aria-hidden="true"></i>
      {{ t("carts.useDiscountCode") }}
    </el-button>

    <el-dialog
      v-model="codeState.visible"
      :title="t('carts.useDiscountCode')"
      :width="isMobile ? '100%' : '600px'"
    >
      <el-form ref="codeFormRef" :model="codeState">
        <el-form-item
          prop="code"
          :rules="[{ validator: validateCode, trigger: 'blur' }]"
        >
          <el-input
            v-model="codeState.code"
            size="large"
            maxlength="20"
            clearable
            show-word-limit
            @change="chkCode"
          >
            <template #append>
              <el-button :disabled="!codeState.code" @click="handleDiscountCode(codeFormRef)">
                {{ t("global.use") }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>

      <el-empty v-if="!codeState.items.length" :description="t('carts.emptyDiscountCode')" />
      <div class="mt-4">
        <el-scrollbar height="400px">
          <PromotionCodeItem
            v-for="item in codeState.items"
            :key="item.store_prom_id"
            :item="item"
            :code-state="codeState"
            @click="onClickPromo"
          />

          <v3-infinite-loading @infinite="loadData">
            <template #complete>
              <h4 class="pt-2 text-muted">{{ t("promotions.emptyCodes") }}</h4>
            </template>
            <template #spinner>
              <span>loading...</span>
            </template>
          </v3-infinite-loading>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'
import V3InfiniteLoading from "v3-infinite-loading"
import { breakpoint, notificationErrors, currencyFormat, dataTranslations as dt } from "../../utils"
import { _api_getAccountPromotionCodes, _api_postAccountPromotionCodes } from "../../api/index.js";
import PromotionCodeItem from "../users-profile/components/PromotionCodeItem.vue"

const props = defineProps({
  form: Object,
  state: Object,
})
const emit = defineEmits(['update:form', 'ok'])

const { t, n, locale } = useI18n()
const form = useVModel(props, 'form', emit)

const isMobile = computed(() => breakpoint.value.xs)

const promotionCodeDiscount = computed(() => {
  const discountCode = codeState.data ? codeState.data : props.state.discountCode
  if (form.value.prom_code_id && discountCode) {
    if (discountCode?.promotion?.discount_type == 'amount') {
      return discountCode?.promotion?.conditions[0].discount_amount
    } else if (discountCode?.promotion?.discount_type == 'percentage') {
      console.log("total: ", codeState.amount)
      let amount = (discountCode?.promotion?.conditions[0].discount_percentage * codeState.amount / 100)
      console.log('amount', amount)
      if (discountCode?.promotion?.conditions[0].discount_amount && amount > discountCode?.promotion?.conditions[0].discount_amount) {
        amount = discountCode?.promotion?.conditions[0].discount_amount
      }
      return Math.round(amount)
    }
  }
  return 0
})

const codeState = reactive({
  visible: false,
  amount: 0,
  code: null,
  data: null,
  items: [],
  paging: {
    after: null,
    before: null,
    has_more: false,
    next: null,
    previous: null,
  },
  params: {
    status: "now",
    limit: 5,
    starting_after: null,
    ending_before: null,
  },
  currency: props.state.currency_symbol,
})

const codeFormRef = ref()

const onClickDiscountCode = async () => {
  if (!codeState.items.length) {
    window.fullPageLoading("show")
    try {
      codeState.params.starting_after = null
      const resp = await _api_getAccountPromotionCodes(codeState.params)
      codeState.items = resp.data.data
      codeState.paging = resp.data.paging

      if (codeState.paging.has_more) {
        codeState.params.starting_after = codeState.paging.after
      }
    } catch (err) {
      notificationErrors(err)
    } finally {
      window.fullPageLoading("hide")
    }
  }
  codeState.visible = true
}

const chkCode = (value) => {
  const item = codeState.items.find((el) => el.promotion.codes[0] == value)
  if (item) {
    codeState.data = item
  } else {
    codeState.data = null
  }
  // console.log("chkCode2: ", codeState.data)
}

const isValidDate = () => {
  if (!codeState.data?.promotion?.start_at) {
    return false
  }
  const unit = "minute"
  const startChk = dayjs().isSameOrAfter(codeState.data?.promotion?.start_at, unit)
  if (codeState.data?.promotion?.ended_at) {
    const endChk = dayjs().isBetween(dayjs(codeState.data?.promotion?.start_at), dayjs(codeState.data?.promotion?.ended_at), unit)
    // console.log("isBetween: ", endChk)
    return endChk
  }
  return startChk
}

const chkProductIds = (arr1, arr2) => {
  // 比對重複的值
  return arr1.filter((val) => arr2.includes(val))
}
const validateCode = (rule, value) => {
  if (!codeState.data || !value) {
    return Promise.reject('請先選擇折扣碼')
  } else {
    // console.log("data: ", value, codeState.data)

    // 檢查使用期限
    if (!isValidDate()) {
      return Promise.reject('此折扣碼已過期或尚未開始')
    }

    // 檢查使用次數
    if (codeState.data?.promotion?.max_use_count && codeState.data.promotion.max_use_count <= codeState.data.promotion.use_count) {
      return Promise.reject('已無剩餘使用次數')
    }
    // 檢查 不適用其他折扣 的cart
    const carts = form.value.carts.filter((el) => el.checked && !el?.is_excluded_discount)
    console.debug("carts: ", carts)
    if (!carts.length) {
      return Promise.reject('購物車中的商品不適用折扣碼')
    }

    codeState.amount = 0
    console.debug("condition_scope: ", codeState.data?.promotion?.condition_scope)
    if (codeState.data?.promotion?.condition_scope == "categories") {
      // 指定分類
      let num = 0
      carts.forEach((cart) => {
        const chkCat = chkProductIds(codeState.data.promotion?.conditions[0].whitelisted_store_cat_ids, cart.store_cat_ids)
        // console.log("chkCat: ", chkCat)

        // 檢查排除assort
        if (chkCat.length) {
          if (codeState.data?.promotion?.conditions[0].blacklisted_store_assort_ids && !!codeState.data.promotion?.conditions[0].blacklisted_store_assort_ids.length) {
            if (!codeState.data.promotion?.conditions[0].blacklisted_store_assort_ids.includes(cart.store_assort_id)) {
              num++
              codeState.amount += cart.sub_total
            }
          } else {
            num++
            codeState.amount += cart.sub_total
          }
        }
      })
      // console.log("num: ", num)
      if (!num) {
        return Promise.reject('購物車中的商品不適用此折扣碼')
      }

    } else if (codeState.data?.promotion?.condition_scope == "products") {
      // 指定商品
      let num = 0
      carts.forEach((cart) => {
        if (codeState.data.promotion?.conditions[0].whitelisted_store_product_ids.includes(cart.store_product_id)) {

          // 檢查排除assort
          if (codeState.data?.promotion?.conditions[0].blacklisted_store_assort_ids && !!codeState.data.promotion?.conditions[0].blacklisted_store_assort_ids.length) {
            if (!codeState.data?.promotion?.conditions[0].blacklisted_store_assort_ids.includes(cart.store_assort_id)) {
              codeState.amount += cart.sub_total
              num++
            }
          } else {
            codeState.amount += cart.sub_total
            num++
          }
        }
      })
      if (!num) {
        return Promise.reject('購物車中的商品不適用此折扣碼')
      }
    } else if (codeState.data?.promotion?.condition_scope == "subtotal") {
      // 全站商品
      let num = 0
      carts.forEach((cart) => {
        // 檢查排除assort
        if (codeState.data?.promotion?.conditions[0].blacklisted_store_assort_ids && !!codeState.data.promotion?.conditions[0].blacklisted_store_assort_ids.length) {
          if (!codeState.data?.promotion?.conditions[0].blacklisted_store_assort_ids.includes(cart.store_assort_id)) {
            codeState.amount += cart.sub_total
            num++
          }
        } else {
          codeState.amount += cart.sub_total
          num++
        }
      })
      if (!num) {
        return Promise.reject('購物車中的商品不適用此折扣碼')
      }
    }
    // 檢查最低消費
    if (codeState.amount < codeState.data?.promotion?.conditions[0].min_amount) {
      const amount = Number(codeState.data?.promotion?.conditions[0].min_amount - codeState.amount)
      return Promise.reject('最低消費還差 $' + currencyFormat(amount))
    }
    return Promise.resolve()
  }
}

const handleDiscountCode = async (formEl) => {
  try {
    if (!formEl) return
    // formEl.clearValidate()
    form.value.prom_code_id = null
    chkCode(codeState.code)

    if (!codeState.data) {
      const resp = await handleCreateDiscountCode()
      // console.log("handleCreateDiscountCode: ", resp)
      if (resp) {
        codeState.items = []
        await onClickDiscountCode()
        codeState.data = codeState.items.find((el) => el.id == resp.id)
      }
    }
    formEl.validate((valid, fields) => {
      if (valid) {
        form.value.prom_code_id = codeState.data.id
        // console.log("formRef: ", form.value)
        // console.log('amount', promotionCodeDiscount.value)
        emit("ok", { amount: promotionCodeDiscount.value, ...codeState.data})
        codeState.visible = false
        codeState.data = null
        codeState.code = null
      } else {
        console.log('error submit!', fields)
        return false
      }
    })

  } catch (err) {
    console.log("handleDiscountCode err: ", err)
    return false
  }
}

const handleCreateDiscountCode = async () => {
  window.fullPageLoading("show")
  try {
    const params = {
      code: codeState.code,
      action: "get_or_create",
    }

    const resp = await _api_postAccountPromotionCodes(params)
    // console.log("handleDiscountCode: ", resp.data.store_prom_id)
    return resp.data
  } catch (err) {
    notificationErrors(err.response.data)
    codeState.code = null
  } finally {
    window.fullPageLoading("hide")
  }
}

const loadData = async ($state) => {
  // window.fullPageLoading("show")
  try {
    if (!codeState.paging.has_more) {
      $state.loaded()
      return
    }
    const resp = await _api_getAccountPromotionCodes(codeState.params)
    codeState.items = [...codeState.items, ...resp.data.data]
    codeState.paging = resp.data.paging

    codeState.params.starting_after = codeState.paging.after
    // console.log("has_more: ", codeState.paging.has_more)
    if (!codeState.paging.has_more) {
      $state.complete()
    } else {
      $state.loaded()
    }

  } catch (err) {
    $state.error()
    notificationErrors(err)
  } finally {
    // window.fullPageLoading("hide")
  }
}

const onClickPromo = (item) => {
  if (codeFormRef.value) {
    codeFormRef.value.clearValidate()
  }
  // console.debug("onClickPromo: ", item)
  if (item.is_valid) {
    codeState.data = item
    codeState.code = item?.promotion?.codes[0]
    handleDiscountCode(codeFormRef.value)
  }
}

const removeDiscountCode = () => {
  codeState.data = null
  codeState.code = null
  form.value.prom_code_id = null
  emit("ok", codeState.data)
}

</script>
